export enum TaskScoreOptions {
    Required = 1,
    NotRequired = 2,
    No = 3,
}
